/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$('.announcementbar-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true
  })

  
  $('.ingredient-section').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1
});

 $('.home-page-blog').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1
});

 $('.customer-review-section').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 1,
   	autoplay: true,
    autoplaySpeed: 2000
});

$('.instagram-section').flickity({
  	cellAlign: 'left',
  	contain: true,
  	wrapAround: true,
    groupCells: 1
});

$('.Product__SlideshowNavScroller').flickity({
  	cellAlign: 'left',
  	contain: true,
    groupCells: 7
});

// Start: Custom JS
$(function(){
  $(document).on('click','.ProductForm__AddToCart_custom', function(event){
   var variant_id = $(this).attr('data-vid');
    addItemToCartOneTime(variant_id,1);
  });
 
  function addItemToCartOneTime (variant_id, quantity) {
    data = {
      "quantity": quantity,
      "id": variant_id,
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        $.getJSON('/cart.json', function(cart){

          var html_data ='';
          var cartTotalItem = cart.item_count;
          var cartTotalPrice = parseFloat(cart.total_price) / 100;

          // 		For update cart count
          if(cartTotalItem > 0){
            $('.Header__CartDot').addClass('is-visible');
            $('.Header__CartDot .Header__CartCount').text(cartTotalItem);
          }
          // 		End code for update cart count

          // Code for update mini cart
          $.ajax({url: "/cart?section_id=mini-cart", 
                  success: function(result) {
                    var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();

                    $("#sidebar-cart").html(successHtml);
                    $(`.Header__CartDot`).trigger('click');
                    
                  }});
  });

      },
      error: function(error) {
                // Handle any errors here
                console.log("Error:", error);
            }
    });
    
  }
}); // endready function



document.addEventListener('click', function (e) {
const button = e.target.closest('.ajax-add-to-cart');
  if (!button) return;
   e.preventDefault();
 const variantId = button.dataset.variantId;
  if (!variantId) return;

  //alert("clicked" + variantId); 
  button.classList.add('loading');
  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log('Added:', data);

    // ✅ Update cart drawer / count
    document.dispatchEvent(new CustomEvent('cart:refresh'));

     $.ajax({url: "/cart?section_id=mini-cart", 
                  success: function(result) {
                    var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();
                    $("#sidebar-cart").html(successHtml);
              }});

    // Optional success UI
    button.innerText = 'Added ✔';
 
    setTimeout(() => {
      button.innerText = 'Add to Cart';
      button.classList.remove('loading');
      button.disabled = false;
    }, 1500);
  })
  .catch(error => {
    console.error('Error:', error);
    button.disabled = false;
    button.classList.remove('loading');
  });
});
  $(document).on("click",".CartItem__Remove",function() {
      var claim_pro_id = $(this).attr('data-product-id');
      console.log("claim_pro_id"+ claim_pro_id);
      $('.cart-recommondation_drawer .ProductItem[data-product="'+claim_pro_id+'"]').show();
     });